import {
  FieldErrors,
  UseFormRegister,
  UseFormUnregister,
  UseFormWatch,
  useForm,
} from "react-hook-form";
import { FormTypes } from "../../types/FormTypes";
import horizontal from "../../images/horizontal 550 no background with axes.png";
import inverted from "../../images/inverted 550 no background with axes.png";
import rolled from "../../images/rolled 550 no background with axes.png";
import vertical from "../../images/vertical 550 no background with axes.png";

interface IInputsPayload {
  register: UseFormRegister<FormTypes>;
  unregister: UseFormUnregister<FormTypes>;
  errors: FieldErrors<FormTypes>;
  watch: UseFormWatch<FormTypes>;
  onBlurHandler: (event: any) => void;
  externalForceCount: number;
  setExternalForceCount: Function;
  momentsCount: number;
  setMomentsCount: Function;
}

function InputsPayload(props: IInputsPayload) {
  const {
    register,
    unregister,
    errors,
    watch,
    onBlurHandler,
    externalForceCount,
    setExternalForceCount,
    momentsCount,
    setMomentsCount,
  } = props;

  const removeExternalForce = () => {
    unregister(`externalForceForceDirection${externalForceCount}` as any);
    unregister(`externalForceAppliedForce${externalForceCount}` as any);
    unregister(`externalForceAppliedForceX${externalForceCount}` as any);
    unregister(`externalForceAppliedForceY${externalForceCount}` as any);
    unregister(`externalForceAppliedForceZ${externalForceCount}` as any);
    setExternalForceCount(externalForceCount - 1);
  };

  const watchOrientation: string = watch("orientation");

  useForm({
    defaultValues: {
      payloadMass: 0,
    },
  });

  return (
    <>
      <div className="d-flex">
        <div className="mr-100">
          <p>Mass</p>
          <div className="d-flex w-100px">
            <input
              type="number"
              step="any"
              placeholder="0"
              className={errors.payloadMass ? "input-error" : ""}
              {...register("payloadMass", {
                min: 0,
                max: 999,
                valueAsNumber: true,
                onBlur: onBlurHandler,
              })}
            />
            <p style={{ marginBottom: "0px", marginLeft: "5px" }}>kg</p>
          </div>
          <small className="input-small-text">0 - 999 kg</small>
        </div>
        <div className="mr-100">
          <p>X Offset</p>
          <div className="d-flex w-100px">
            <input
              type="number"
              step="any"
              placeholder="0"
              className={errors.payloadXOffset ? "input-error" : ""}
              {...register("payloadXOffset", {
                min: -9999,
                max: 9999,
                valueAsNumber: true,
                onBlur: onBlurHandler,
              })}
            />
            <p style={{ marginBottom: "0px", marginLeft: "5px" }}>mm</p>
          </div>
          <small className="input-small-text">-9999 - 9999 mm</small>
        </div>
        <div className="mr-100">
          <p>Y Offset</p>
          <div className="d-flex w-100px">
            <input
              type="number"
              step="any"
              placeholder="0"
              className={errors.payloadYOffset ? "input-error" : ""}
              {...register("payloadYOffset", {
                min: -9999,
                max: 9999,
                valueAsNumber: true,
                onBlur: onBlurHandler,
              })}
            />
            <p style={{ marginBottom: "0px", marginLeft: "5px" }}>mm</p>
          </div>
          <small className="input-small-text">-9999 - 9999 mm</small>
        </div>
        <div className="mr-100">
          <p>Z Offset</p>
          <div className="d-flex w-100px">
            <input
              type="number"
              step="any"
              placeholder="0"
              className={errors.payloadZOffset ? "input-error" : ""}
              {...register("payloadZOffset", {
                min: -9999,
                max: 9999,
                valueAsNumber: true,
                onBlur: onBlurHandler,
              })}
            />
            <p style={{ marginBottom: "0px", marginLeft: "5px" }}>mm</p>
          </div>
          <small className="input-small-text">-9999 - 9999 mm</small>
        </div>
        <div>
          {watchOrientation ? (
            <img
              height={150}
              alt=""
              src={
                watchOrientation === "orientationHorizontal"
                  ? horizontal
                  : watchOrientation === "orientationRolled"
                  ? rolled
                  : watchOrientation === "orientationVertical"
                  ? vertical
                  : watchOrientation === "orientationInverted"
                  ? inverted
                  : ""
              }
            />
          ) : null}
        </div>
      </div>
      <div className="d-flex mt2" style={{ flexDirection: "column" }}>
        <div className="mt2">
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="orange-button small-btn"
              onClick={() => removeExternalForce()}
              disabled={externalForceCount === 0}
            >
              -
            </button>
            <p
              style={{
                marginBottom: "0px",
                marginLeft: "5px",
                marginRight: "5px",
              }}
            >
              Add External Force(s)
            </p>
            <button
              type="button"
              className="orange-button small-btn"
              onClick={() => setExternalForceCount(externalForceCount + 1)}
              disabled={externalForceCount === 3}
            >
              +
            </button>
          </div>
          {Array.from({ length: externalForceCount }).map((_item, index) => (
            <div
              className="d-flex mt2"
              key={`externalForceForceGroup${index + 1}`}
            >
              <div className="mr-100">
                <p>Force Direction {index + 1}</p>
                <select
                  className="mr-25"
                  {...register(
                    `externalForceForceDirection${index + 1}` as any
                  )}
                >
                  <option value="X">X</option>
                  <option value="X">Y</option>
                  <option value="Z">Z</option>
                </select>
              </div>
              <div className="mr-100">
                <p>Applied Force</p>
                <div className="d-flex w-100px">
                  <input
                    type="number"
                    step="any"
                    placeholder="0"
                    className={
                      errors[
                        `externalForceAppliedForce${
                          index + 1
                        }` as keyof typeof errors
                      ]
                        ? "input-error"
                        : ""
                    }
                    {...register(
                      `externalForceAppliedForce${index + 1}` as any,
                      {
                        min: -9999,
                        max: 9999,
                        valueAsNumber: true,
                        onBlur: onBlurHandler,
                      }
                    )}
                  />
                  <p style={{ marginBottom: "0px", marginLeft: "5px" }}>N</p>
                </div>
                <small className="input-small-text">-9999 - 9999 N</small>
              </div>
              <div className="mr-100">
                <p>Applied Force X Offset</p>
                <div className="d-flex w-100px">
                  <input
                    type="number"
                    step="any"
                    placeholder="0"
                    className={
                      errors[
                        `externalForceAppliedForceX${
                          index + 1
                        }` as keyof typeof errors
                      ]
                        ? "input-error"
                        : ""
                    }
                    {...register(
                      `externalForceAppliedForceX${index + 1}` as any,
                      {
                        min: -9999,
                        max: 9999,
                        valueAsNumber: true,
                        onBlur: onBlurHandler,
                      }
                    )}
                  />
                  <p style={{ marginBottom: "0px", marginLeft: "5px" }}>mm</p>
                </div>
                <small className="input-small-text">-9999 - 9999 mm</small>
              </div>
              <div className="mr-100">
                <p>Applied Force Y Offset</p>
                <div className="d-flex w-100px">
                  <input
                    type="number"
                    step="any"
                    placeholder="0"
                    className={
                      errors[
                        `externalForceAppliedForceY${
                          index + 1
                        }` as keyof typeof errors
                      ]
                        ? "input-error"
                        : ""
                    }
                    {...register(
                      `externalForceAppliedForceY${index + 1}` as any,
                      {
                        min: -9999,
                        max: 9999,
                        valueAsNumber: true,
                        onBlur: onBlurHandler,
                      }
                    )}
                  />
                  <p style={{ marginBottom: "0px", marginLeft: "5px" }}>mm</p>
                </div>
                <small className="input-small-text">-9999 - 9999 mm</small>
              </div>
              <div className="mr-100">
                <p>Applied Force Z Offset</p>
                <div className="d-flex w-100px">
                  <input
                    type="number"
                    step="any"
                    placeholder="0"
                    className={
                      errors[
                        `externalForceAppliedForceZ${
                          index + 1
                        }` as keyof typeof errors
                      ]
                        ? "input-error"
                        : ""
                    }
                    {...register(
                      `externalForceAppliedForceZ${index + 1}` as any,
                      {
                        min: -9999,
                        max: 9999,
                        valueAsNumber: true,
                        onBlur: onBlurHandler,
                      }
                    )}
                  />
                  <p style={{ marginBottom: "0px", marginLeft: "5px" }}>mm</p>
                </div>
                <small className="input-small-text">-9999 - 9999 m</small>
              </div>
            </div>
          ))}
          <div className="d-flex align-items-center mt2">
            <button
              type="button"
              className="orange-button small-btn"
              onClick={() => setMomentsCount(momentsCount - 1)}
              disabled={momentsCount === 0}
            >
              -
            </button>
            <p
              style={{
                marginBottom: "0px",
                marginLeft: "5px",
                marginRight: "5px",
              }}
            >
              Add Moments
            </p>
            <button
              type="button"
              className="orange-button small-btn"
              onClick={() => setMomentsCount(momentsCount + 1)}
              disabled={momentsCount === 1}
            >
              +
            </button>
          </div>
          {Array.from({ length: momentsCount }).map((_item, index) => (
            <div
              className="d-flex mt2"
              key={`externalForceForceGroup${index + 1}`}
            >
              <div className="mr-100">
                <p>Moment X</p>
                <div className="d-flex w-150px">
                  <input
                    type="number"
                    step="any"
                    placeholder="0"
                    className={
                      errors.externalForceMomentX1 ? "input-error" : ""
                    }
                    {...register("externalForceMomentX1", {
                      min: -99,
                      max: 99,
                      valueAsNumber: true,
                      onBlur: onBlurHandler,
                    })}
                  />
                  <p
                    className="w-50px"
                    style={{ marginBottom: "0px", marginLeft: "5px" }}
                  >
                    N-m
                  </p>
                </div>
                <small className="input-small-text">-99 - 99 N-m</small>
              </div>
              <div className="mr-100">
                <p>Moment Y</p>
                <div className="d-flex w-150px">
                  <input
                    type="number"
                    step="any"
                    placeholder="0"
                    className={
                      errors.externalForceMomentY1 ? "input-error" : ""
                    }
                    {...register("externalForceMomentY1", {
                      min: -99,
                      max: 99,
                      valueAsNumber: true,
                      onBlur: onBlurHandler,
                    })}
                  />
                  <p
                    className="w-50px"
                    style={{ marginBottom: "0px", marginLeft: "5px" }}
                  >
                    N-m
                  </p>
                </div>
                <small className="input-small-text">-99 - 99 N-m</small>
              </div>
              <div className="mr-100">
                <p>Moment Z</p>
                <div className="d-flex w-150px">
                  <input
                    type="number"
                    step="any"
                    placeholder="0"
                    className={
                      errors.externalForceMomentZ1 ? "input-error" : ""
                    }
                    {...register("externalForceMomentZ1", {
                      min: -99,
                      max: 99,
                      valueAsNumber: true,
                      onBlur: onBlurHandler,
                    })}
                  />
                  <p
                    className="w-50px"
                    style={{ marginBottom: "0px", marginLeft: "5px" }}
                  >
                    N-m
                  </p>
                </div>
                <small className="input-small-text">-99 - 99 N-m</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default InputsPayload;
